<div class="static-toast {{ type }}">
  <div class="static-toast-content">
    <div>
      <span *ngIf="icon">
        <img class="icon" src="/assets/icons/{{ icon }}.svg" alt="done" />
      </span>
      <span class="/static-toast-content-message">
        <ng-content></ng-content>
      </span>
    </div>
  </div>
  <span class="toast-close" (click)="onClose()">
    <img src="/assets/icons/icons-close.svg" alt="close" />
  </span>
</div>
